import styled from 'styled-components';
import { setAlpha } from '../../../../styles/utils';
import { Box, HStack } from '../../../Core';

export const OverflowModalWrapper = styled(Box)`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

/** Contains DND so drags do not translate into horizontal viewport / rubber-band scroll. */
export const OverflowDndArea = styled(Box)`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing4}px;
`;

export const OverflowHeader = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const OverflowRow = styled(HStack)<{ isSelected?: boolean }>`
  max-width: 100%;
  overflow: hidden;
  border-radius: ${({ theme }) => theme.spacing8}px;
  background: ${({ theme, isSelected }) =>
    isSelected ? setAlpha(0.8, theme.colors.gray['050']) : theme.colors.gray['020']};
  padding-left: ${({ theme }) => theme.spacing4}px;
  padding-right: ${({ theme }) => theme.spacing12}px;
  flex: 0 0 auto;
`;

export const OverflowRowButton = styled.button`
  display: flex;
  align-items: center;
  background: transparent;
  border: none;
  color: inherit;
  text-align: left;
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  gap: ${({ theme }) => theme.spacing12}px;
  padding: ${({ theme }) => `${theme.spacing12}px ${theme.spacing8}px`};
  -webkit-touch-callout: none;
  user-select: none;
`;

export const OverflowDragHandle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: -4px;
  padding: 8px;
  cursor: grab;
  color: ${({ theme }) => theme.colorTextSubtle};
  touch-action: none;

  &:active {
    cursor: grabbing;
  }
`;
